import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetProductionInfo } from '../../../../api/productions/productions';
import { useGetSectionPrivilege } from '../../../../api/sections/sections';
import { useDefaultOptions } from '../../../../hooks/api';
import Link from '../../../atoms/Link';
import WaitComponent from '../../../atoms/WaitComponent';
import { SectionIndex } from './SectionIndex';

interface Props {
  productionNo: string | undefined;
  title: string | undefined;
}

/**
 * タブタイトル
 * @returns
 */
function Title({ productionNo, title }: Props) {
  // 言語情報
  const { t } = useTranslation();
  return (
    <Helmet>
      <meta httpEquiv="Pragma" content="no-cache" />
      <meta httpEquiv="Cache-Control" content="no-cache" />
      <title>
        {t('CMS-POC|原稿編集')} {String(productionNo)}：{String(title)}
      </title>
    </Helmet>
  );
}

function SectionPage() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { productionId } = useParams();
  const options = useDefaultOptions(language);

  let mainPage = false;
  const { data: sectionPrivilegeData, isLoading: sectionPrivilegeIsLoading } = useGetSectionPrivilege(options);
  const { data: productionInfo } = useGetProductionInfo(Number(productionId), options);

  // 待ち状態
  if (sectionPrivilegeIsLoading) {
    return (
      <div id="main">
        <WaitComponent />
      </div>
    );
  }

  if (sectionPrivilegeData != null && sectionPrivilegeData.data != null) {
    mainPage = sectionPrivilegeData.data.main ?? false;
  }

  return (
    <div id="main">
      <Title productionNo={productionInfo?.data.production_no} title={productionInfo?.data.title} />
      {mainPage === true ? (
        <section>
          {productionInfo && (
            <SectionIndex productionId={Number(productionId)} sectionPrivilege={sectionPrivilegeData?.data} />
          )}
        </section>
      ) : (
        <div className="center">
          <p className="logouttxt">{t('原稿閲覧権限がありません')}</p>
          <ul>
            <li className="">
              <Link to={`/${language}/productions/edit/${Number(productionId)}`}>
                <i className="fa-solid fa-pen-to-square" />
                {t('制作管理に戻る')}
              </Link>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
export default SectionPage;
